import React from 'react';

const MenuIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    {/* Ícono del menú */}
    <svg style={{ color: '#0f0f0f', fontSize: '16px', width: '16px', height: '16px' }} viewBox="0 0 512 512">
      <path d="M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path>
    </svg>
   
  </div>
);

export default MenuIcon;
